
/** npm import */
import {React, useEffect, useState} from 'react'
import { useNavigate } from 'react-router';
import { BiSearch } from "react-icons/bi";

/** local file import */
import Header from '../Layout/header'
import verifyAccoutImage from '../Assets/svg/verify_acc.svg'
import resetPasswordImage from '../Assets/svg/Reset_pw.svg'
import unlockAccountImage from '../Assets/svg/unlock_acc.svg'
import resetPhoneImage from '../Assets/svg/reset_phone.svg'
import changeEmailImage from '../Assets/svg/change_mail.svg'
import resetGoogleImage from '../Assets/svg/google_authen.svg'
import cryptoDepositImage from '../Assets/svg/crypto_deposit.svg'
import appealP2pImage from '../Assets/svg/p2p.svg'
import assetsFrozenImage from '../Assets/svg/p2p_dispute.svg'
import selfToolImage from '../Assets/svg/self_tool.svg'
import Footer from '../Layout/footer';
import Subscriber from '../Layout/subscribe';
import { GetuserData } from '../Axios/user.axios';
import config from '../helper/config';
import { toast } from 'react-toastify';



/** code start */

const Support = () => {

    const navigate = useNavigate()

    const [DisableStatus, SetDiableStatus] = useState(false);

    const handleNavLink = (url) => {
        if(url){
            navigate(url)
        }
        else{
            navigate('/faq')
        }
    }

    useEffect(() => {
        window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    });

    useEffect(() => {
        let cookie = ("; " + document.cookie)
            .split(`; ${config.cookiename}=`)
            .pop()
            .split(";")[0];
        if (cookie) {
            GetUserProfile(cookie);
        }
        else {
            navigate('/')
            toast.error("Login for Contact Support")
        }
    }, [])

    const GetUserProfile = async(cookie) => {
        if(!DisableStatus){
            SetDiableStatus(true);
            let resp = await GetuserData({ data: cookie, kyc: false })
            console.log("🚀 ~ GetUserProfile ~ resp:", resp)
            if(resp?.status){
            }
            else{
                navigate('/');
            }
            SetDiableStatus(false);
        }
    }

    return (
        <div>
            <Header />
            <section className='custom_section'>
                <div className='container py-4 py-md-5'>
                    <div>
                        <h2 className='color-brand-1 mb-15'>Help Center</h2>

                        {/* <h5 className='mt-4 mt-md-5 support_title'>Search our FAQ</h5>
                        <div className='support_search_wrapper d-flex align-items-center justify-content-between mt-4 gap-1 gap-sm-3'>
                            <div className='d-flex align-items-center w-100'>
                                <BiSearch fontSize={25} className='mx-1 mx-sm-3' fill='rgb(183, 189, 198)' />
                                <input
                                    className='w-100'
                                    placeholder='Search help articles' />
                            </div>
                            <button className='support_search_button'>
                                Search
                            </button>

                        </div> */}

                        <div className='mt-4 mt-md-5'>
                            <h5 className='support_title'>Self-Service</h5>
                            <div className='self_service_card_wrapper mt-4'>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={()=>handleNavLink('/reactivate')}>
                                    <img
                                        src={unlockAccountImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>ReActivate Account</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={()=>handleNavLink('/edit-email')}>
                                    <img
                                        src={changeEmailImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Change Email Address</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={()=>handleNavLink('/support-ticket')}>
                                    <img
                                        src={selfToolImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Support Ticket</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={()=>handleNavLink('/edit-name')}>
                                    <img
                                        src={changeEmailImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Name Correction</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={()=>handleNavLink('/withdraw-support')}>
                                    <img
                                        src={changeEmailImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Crypto withdrawal dispute support</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={()=>handleNavLink('/deposit-support')}>
                                    <img
                                        src={cryptoDepositImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Crypto deposit dispute support</p>
                                </div>
                                {/* 

                                <div className='self_service_card d-flex flex-column align-items-center' onClick={handleNavLink}>
                                    <img
                                        src={verifyAccoutImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Verify Account</p>
                                </div>
                                
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={handleNavLink}>
                                    <img
                                        src={resetPasswordImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Reset Password</p>
                                </div>
                                
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={handleNavLink}>
                                    <img
                                        src={resetPhoneImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Reset Phone Security Verification</p>
                                </div>
                                
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={handleNavLink}>
                                    <img
                                        src={resetGoogleImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Reset Google Authenticator</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={handleNavLink}>
                                    <img
                                        src={cryptoDepositImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Crypto Deposit Not Credited</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={handleNavLink}>
                                    <img
                                        src={appealP2pImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Appeal P2P Performance Metrics</p>
                                </div>
                                <div className='self_service_card d-flex flex-column align-items-center' onClick={handleNavLink}>
                                    <img
                                        src={assetsFrozenImage}
                                        className='img-fluid'
                                        alt='verify' />
                                    <p className='mt-3 text-center'>Assets Frozen Due to P2P Dispute</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Subscriber />
            <Footer />
        </div>
    )
}

export default Support